import { FC } from 'react'

import { UseAnimatedNumberOptions, useAnimatedNumber } from '@hooks/useAnimatedNumber'
import { useFormatNumber } from '@hooks/useFormatNumber'

import styles from './AnimatedNumber.module.scss'

interface AnimatedNumberProps extends UseAnimatedNumberOptions {
  value: number
  currency?: string
}

export const AnimatedNumber: FC<AnimatedNumberProps> = ({
  value,
  currency,
  durationMs,
  initialValue,
  isReady,
}) => {
  const { formatMoney, formatNumber } = useFormatNumber()
  const animatedValue = useAnimatedNumber(value, { durationMs, initialValue, isReady })

  return (
    <span className={styles.number}>
      {currency !== undefined ? formatMoney(animatedValue, currency) : formatNumber(animatedValue)}
    </span>
  )
}
